import StackNLoadStar from './StackNLoadStar'

interface Props {
  stars: number
}

export default function StackNLoadStars({ stars }: Props): React.ReactElement {
  return (
    <div className="flex items-center lg:pl-24">
      <StackNLoadStar disabled={stars < 1} />
      <div className="mb-4">
        <StackNLoadStar disabled={stars < 2} />
      </div>
      <StackNLoadStar disabled={stars < 3} />
    </div>
  )
}
